import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "../../../firebase";

const GetAllHostelRooms = async (uid, SchoolID) => {
  if (uid && SchoolID) {
    try {
      const HostelCollection = collection(db, "Hostel");

      const q = query(
        HostelCollection,
        where("uid", "==", uid),
        where("SchoolID", "==", SchoolID),
        where("IsDeleted", "==", false)
      );
      const HostelSnapshot = await getDocs(q);

      let HostelData = [];

      HostelSnapshot.forEach((doc) => {
        HostelData.push({ ...doc.data(), id: doc.id });
      });
      return HostelData;
    } catch (error) {
      console.log(error);
    }
  }
};

export default GetAllHostelRooms;
